import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
export const UnichainLogoSquare = t0 => {
  const $ = _c(12);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[4] = size;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs><radialGradient cx="42.5%" cy="40%" id="unichain-logo-square-gradient" r="101.25%"><stop offset="0%" stopColor="#FC74FE" /><stop offset="100%" stopColor="#F50DB4" /></radialGradient></defs>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <g fill="none" fillRule="nonzero"><rect fill="url(#unichain-logo-square-gradient)" height={24} rx={0} width={24} /><path d="M20.4 11.84a8.24 8.24 0 0 1-8.24-8.24h-.32v8.24H3.6v.32a8.24 8.24 0 0 1 8.24 8.24h.32v-8.24h8.24v-.32Z" fill="#FFF" /></g>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== className || $[9] !== rest || $[10] !== t2) {
    t5 = <svg className={className} style={t2} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}{t4}</svg>;
    $[8] = className;
    $[9] = rest;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export const UnichainLogoSquareMonochrome = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M0 0h24v24H0V0Zm12.16 3.6h-.32v8.24H3.6v.32a8.24 8.24 0 0 1 8.24 8.24h.32v-8.24h8.24v-.32a8.24 8.24 0 0 1-8.24-8.24Z" fill={fillAttribute} fillRule="evenodd" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};